export default "__VITE_ASSET__Gr176avW__"